import { createAction } from 'redux-actions'
export const setGiftCardCart = createAction('SET_GIFT_CARD_CART')
export const setGiftCardOrder = createAction('SET_GIFT_CARD_ORDER')
export const emptyGiftCardCart = createAction('EMPTY_GIFT_CARD_CART')
